/* eslint-disable ember/no-computed-properties-in-native-classes */
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import dayjs from 'dayjs';

export default class DayDetailControllerBaseController extends Controller {
  queryParams = ['date', 'offset', 'type'];

  @service router;

  offset = 0;
  type = null;

  @computed('isPricingAssistantProduct', 'pricingAssistantController', 'rates')
  get dayDetailParentController() {
    if (this.isPricingAssistantProduct) {
      return this.pricingAssistantController;
    }

    return this.rates;
  }

  @computed('model.hotel')
  get hotel() {
    return this.model?.hotel;
  }

  @computed('dayDetailParentController.otaId')
  get otaId() {
    return this.dayDetailParentController?.otaId;
  }

  @computed('model.periods')
  get periods() {
    return this.model?.periods;
  }

  @computed(
    'hotel.roomtype.roomtypeSelections',
    'dayDetailParentController.roomType',
  )
  get room() {
    const roomtypeSelections = (
      this.hotel?.roomtype?.roomtypeSelections ?? []
    ).filter(
      (roomtypeSelection) =>
        roomtypeSelection.id === this.dayDetailParentController?.roomType,
    );
    let room = null;
    if (roomtypeSelections.length) {
      room = roomtypeSelections[0].id;
    } else {
      room = this.dayDetailParentController?.roomType;
    }
    return room === 'all' || room.id === 'all' ? null : room;
  }

  @computed('dayDetailParentController.selectedOTA')
  get selectedOTA() {
    return this.dayDetailParentController?.selectedOTA;
  }

  @action
  changeDay(next) {
    if (next) {
      this.router.legacyTransitionTo({
        queryParams: {
          date: dayjs.utc(this.date).add(1, 'day').format('YYYY-MM-DD'),
        },
      });
    } else {
      this.router.legacyTransitionTo({
        queryParams: {
          date: dayjs.utc(this.date).subtract(1, 'day').format('YYYY-MM-DD'),
        },
      });
    }
  }

  @action
  updateOffset(offset) {
    this.router.transitionTo({ queryParams: { offset } });
  }

  @action
  updateType(type) {
    this.router.transitionTo({ queryParams: { type, offset: 0 } });
  }
}
